import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-61fbc56e"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "M-Auto DialogContainer" }
const _hoisted_3 = {
  class: "DialogBody",
  style: {"width":"auto","max-width":"none"}
}
const _hoisted_4 = { class: "W-100" }
const _hoisted_5 = { id: "TableToPrint1" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1))
const _hoisted_8 = { class: "DialogSection FlexColumn" }
const _hoisted_9 = ["Key"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1))
const _hoisted_11 = {
  class: "D-Flex",
  style: {"gap":"1em"}
}
const _hoisted_12 = { class: "F-Bold M-Auto" }
const _hoisted_13 = { class: "F-Bold M-Auto" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRow F-C2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DialogDisabler = _resolveComponent("DialogDisabler")!
  const _component_CookiesCheckBox = _resolveComponent("CookiesCheckBox")!
  const _component_CookiesNumberInput = _resolveComponent("CookiesNumberInput")!
  const _component_CookiesIcon = _resolveComponent("CookiesIcon")!

  return (_openBlock(), _createElementBlock("div", {
    id: 'CookiesDialog_' + _ctx.DialogIndex,
    class: "CookiesDialogdBody"
  }, [
    (_ctx.Saving || _ctx.Loading.length)
      ? (_openBlock(), _createBlock(_component_DialogDisabler, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.PayrollItemTypes, (PayrollItemType) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "PayrollItemsSection",
                  Key: PayrollItemType.ID
                }, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.Translate(PayrollItemType.Name)), 1),
                  _createVNode(_component_CookiesCheckBox, {
                    Type: 'Switch',
                    Res: `'D_Position_PayrollItemType_${PayrollItemType.ID}_Checked'`
                  }, null, 8, ["Res"]),
                  _createElementVNode("span", null, _toDisplayString(_ctx.Translate(PayrollItemType.Type)), 1),
                  _createElementVNode("span", null, _toDisplayString(_ctx.Translate('Percentage')), 1),
                  _createVNode(_component_CookiesNumberInput, {
                    Disabled: !PayrollItemType?.IsCustomizable,
                    IsPercentage: true,
                    Step: 0.01,
                    MinWidth: '3em',
                    Unit: '%',
                    CookiesInvalidInput: !_ctx.MEMRead(`'D_PayrollItemType_Percentage_${PayrollItemType.ID}'`) && _ctx.MEMRead(`'D_PayrollItemType_Percentage_${PayrollItemType.ID}'`) === '',
                    ErrorData: _ctx.ErrorsVisibilty && (!_ctx.MEMRead(`'D_PayrollItemType_Percentage_${PayrollItemType.ID}'`) && _ctx.MEMRead(`'D_PayrollItemType_Percentage_${PayrollItemType.ID}'`) === ''),
                    Res: `'D_PayrollItemType_Percentage_${PayrollItemType.ID}'`,
                    Default: PayrollItemType?.Percentage,
                    DefaultReset: true
                  }, null, 8, ["Disabled", "CookiesInvalidInput", "ErrorData", "Res", "Default"]),
                  _createElementVNode("span", null, _toDisplayString(_ctx.Translate('Fixed')), 1),
                  _createVNode(_component_CookiesNumberInput, {
                    Disabled: !PayrollItemType?.IsCustomizable,
                    Step: 5,
                    MinWidth: '3em',
                    Unit: _ctx.PriceUnit,
                    CookiesInvalidInput: !_ctx.MEMRead(`'D_PayrollItemType_Fixed_${PayrollItemType.ID}'`) && _ctx.MEMRead(`'D_PayrollItemType_Fixed_${PayrollItemType.ID}'`) === '',
                    ErrorData: _ctx.ErrorsVisibilty && (!_ctx.MEMRead(`'D_PayrollItemType_Fixed_${PayrollItemType.ID}'`) && _ctx.MEMRead(`'D_PayrollItemType_Fixed_${PayrollItemType.ID}'`) === ''),
                    Res: `'D_PayrollItemType_Fixed_${PayrollItemType.ID}'`,
                    Default: PayrollItemType?.Fixed,
                    DefaultReset: true
                  }, null, 8, ["Disabled", "Unit", "CookiesInvalidInput", "ErrorData", "Res", "Default"]),
                  _hoisted_10
                ], 8, _hoisted_9))
              }), 256))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.printIT('TableToPrint1'))),
            class: "Shadow2 PrintButton D-Flex RowMargin NOPRINT"
          }, [
            _createVNode(_component_CookiesIcon, {
              class: "V-Auto",
              style: {"width":"1.1em","height":"1.7em","margin":"0 0.3em"},
              ID: 'Printer'
            }),
            _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.Translate('Print')), 1)
          ]),
          _createElementVNode("div", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.go(-1))),
            class: "PrintButton Shadow2 BGRed D-Flex RowMargin NOPRINT",
            style: {"background-color":"var(--colorr1)"}
          }, [
            _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.Translate('Close')), 1)
          ])
        ]),
        _hoisted_14,
        _hoisted_15
      ])
    ])
  ], 8, _hoisted_1))
}